// import {useState, useEffect, useRef} from "react";
// import SectionTitle from "../SectionTitles/SectionTitle";
import SectionTitleTwo from "../SectionTitles/SectionTitleTwo";
// import Tilt from 'react-parallax-tilt';
// import Parallax from 'parallax-js';
// import {Link} from "react-router-dom";

const HomeAbout = () => {
  // const [scale] = useState(1.04);
  // const sceneEl = useRef(null);

  // useEffect(() => {
  //     const parallaxInstance = new Parallax(sceneEl.current, {
  //     relativeInput: true,
  //     })

  //     parallaxInstance.enable();

  //     return () => parallaxInstance.disable();

  // }, [])
  return (
    <div className="section section-padding-t90 section-padding-bottom-100">
      <div className="container">
        {/* <SectionTitle title="Introduction" /> */}

        <div className="row">
          <div
            className="col-xl-6 col-lg-6 col-12"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <div className="about-content-area">
              <SectionTitleTwo
                // subTitle="Every day brings new challenges"
                title="Overview of International Conference on Swarm Intelligence (ICSI)"
              />
              <div className="intro">
                <p>
                Swarm intelligence (SI) is an important concept in artificial intelligence and computer science with emergent properties. SI is one of the most effective methods to confront the modern complex problems in real world. A lot of novel algorithms are springing up. ICSI provides the best communication opportunities for SI researchers and practitioners annually.
                </p>
                <br></br>
                <p>
                  The International Conference on Swarm Intelligence (ICSI) is the leading international conference in the field of swarm intelligence, according to the rankings by Google Scholar. With an outstanding reputation, ICSI is renowned for its excellence in research and innovation. The conference has consistently demonstrated its prominence by attracting high-quality papers with remarkable citation rates and a significant number of downloads for its conference proceedings, consistently placing it at the forefront of Springer-Nature publications. Join us at ICSI to explore the latest advancements, engage with renowned experts, and contribute to the cutting-edge research in the field of swarm intelligence. Don&apos;t miss this opportunity to be part of the premier global event in swarm intelligence research and make a lasting impact on the future of the field.
                  <br></br>
                  <br></br>

                  In summary:
                  <br></br>
                  <br></br>

                  <ul>
                    <li>
                      ICSI is the top international conference in the field of swarm intelligence, as per Google Scholar rankings.

                    </li>
                    <li>

                      The conference&apos;s paper citation rates and conference proceedings&apos; download statistics consistently position it at the forefront of Springer-Nature publications.
                    </li>
                    <li>
                      ICSI offers a platform for researchers and experts to present and discuss the latest advancements in swarm intelligence.

                    </li>
                  </ul>
                <br></br>

                  {/* Join ICSI to network with renowned professionals and contribute to groundbreaking research in swarm intelligence.
                  Be a part of the premier global event in swarm intelligence research and shape the future of this dynamic field. */}
                </p>

              </div>

              {/* <Link className="btn btn-primary btn-hover-secondary mt-xl-8 mt-lg-8 mt-md-6 mt-4" to={process.env.PUBLIC_URL + "/about"}>Learn More</Link> */}
            </div>
          </div>

          <div
            className="col-xl-6 col-lg-6 col-12"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <div className="about-content-area">
              {/* <SectionTitleTwo 
                                // subTitle="Every day brings new challenges"
                                title="International Conference on Swarm Intelligence"
                            /> */}

              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <p>
              Yokohama, Japan&apos;s second-largest city, is a captivating blend of tradition and modernity. Known for its stunning waterfront and the iconic Minato Mirai district, the city boasts a skyline adorned with futuristic architecture, including the famous Landmark Tower. The rich culinary scene in Yokohama features delicious local dishes, such as the iconic Yokohama-style ramen and fresh seafood from its bustling markets. The city is also home to beautiful parks, like Sankeien, which showcases traditional Japanese gardens and historical buildings. Additionally, Yokohama is a hub for innovation, with attractions such as the Cup Noodles Museum and the Ramen Museum, offering interactive experiences. With its warm atmosphere, cultural diversity, and scenic beauty, Yokohama is a must-visit destination for any traveler.
              </p>
              {/* <p>
                The ICSI&apos;2024 is the Fifteenth annual event in this
                high-reputation ICSI series following the continuous twelfth
                previous events at Shenzhen, Xi&apos;an (Online Webinar), Qingdao
                ,Belgrade (Online Webinar), Chiang Mai, Shanghai, Fukuoka, Bali,
                Beijing, Hefei, Harbin, Shenzhen, Chongqing and Beijing.
              </p> */}
              <br></br>
              <p>
                Papers presented at the ICSI&apos;2025 will be published by
                Springer-Nature in Lecture Notes in Computer Science (indexed by
                EI Compendex, ISTP, DBLP, SCOPUS, Web of Science ISI Thomson,
                etc.). The downloads of our meeting&apos;s proceedings reach the
                top 10% of all publications of Springer-Nature.
              </p>
              <br></br>
              <p>
                Some high-quality papers will be selected for SCI-indexed Transaction and Journal (including IEEE Trans, IASEI Trans. Swarm Intelligence, IJSIR, Swarm and Evolutionary Optimization, Frontier in Neuroscience, Springer-Nature (SN) Computer Science, etc.) and Journal Special Issues:
                {/* <li>
                  International Journal of Intelligent System (IJIS, IF=10.78)
                </li> */}
                <li>Frontier in Neuroscience (IF=4.501)</li>
                <li>Electronics (IF=2.412)</li>
                <li>Entropy (IF=2.524)</li>
                {/* <li>Algorithms (IF=2.267)</li> */}
                <li>SN Computer science</li>
                {/* <li>IASEI Transactions on Swarm Intelligence</li> */}
                <li>……</li>
              </p>

              {/* <Link className="btn btn-primary btn-hover-secondary mt-xl-8 mt-lg-8 mt-md-6 mt-4" to={process.env.PUBLIC_URL + "/about"}>Learn More</Link> */}
            </div>
          </div>
        </div>
      </div>
      <div className="space-50"></div>
    </div>
  );
};

export default HomeAbout;
